import React, { FC } from 'react';
import { Modal } from 'antd';
import { ReactComponent as Intensity_setupIcon } from '../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg';
import { ReactComponent as CloseIcon } from 'src/assets/images/trainer/clients/close.svg';
import { EquipmentIcon } from 'src/utils/equipmentIcons';
import './EquipmentsModal.scss';

interface EquipmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  equipments: string[];
  getSlugTitle: (slug: string) => string;
}

export const EquipmentsModal: FC<EquipmentsModalProps> = ({
  isOpen,
  onClose,
  equipments,
  getSlugTitle,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={540}
      rootClassName="equipments-list-modal"
      closeIcon={<CloseIcon className="modal-close-icon" />}
    >
      <div className="equipments-modal-content">
        <div className="modal-header">
          <div className="header-left">
            <div className="header-icon">
              <Intensity_setupIcon />
            </div>
            <div className="header-text">
              <h3>Equipments</h3>
              <span className="subtitle">{equipments.length} equipments configured</span>
            </div>
          </div>
        </div>

        <div className="equipments-grid">
          {equipments.map((eq, idx) => (
            <div key={idx} className="equipment-item-card">
              <span className="eq-name">{getSlugTitle(eq)}</span>
              <div className="eq-icon-wrapper">
                <EquipmentIcon slug={eq} />
              </div>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button className="btn-close" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
};
